import API from './API.js'

export default class Blogs extends API {
  constructor() {
    super('blogs')
  }
}
